
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/performances/[id]",
      function () {
        var mod = require("private-next-pages/performances/[id].tsx");
        if (false && module.hot) {
          module.hot.accept("private-next-pages/performances/[id].tsx", function () {
            if (!next.router.components["/performances/[id]"]) return;
            var updatedPage = require("private-next-pages/performances/[id].tsx");
            next.router.update("/performances/[id]", updatedPage);
          });
        }
        return mod;
      }
    ]);
  